import { PrivatePolicyValidationStatus } from "../reports/useReportsStore/privatePolicyReportSlice";
import http from "./http-common";

export interface PrivatePolicyData {
  locationId: number;
  tenantName: string;
  email: string;
  moveInDate?: Date;
  unitName?: string;
  insuranceCompany: string | null;
  policyNumber: string;
  policyDeductible: number | null;
  expiration: Date | null;
  attachment: File | null;
  policyExpirationRemindersEnabled: boolean;
  uploadSuccessEmailEnabled?: boolean;
  attachSuccessEmailEnabled?: boolean;
  rejectionEmailEnabled?: boolean;
  matchedSafeleaseUnitIdOnSubmit?: number;
  attachment_filename?: string;
  attachment_desired_filename?: string;
  attachment_mime_type?: string;
  isValidFile?: string;
}

class PrivatePolicyDataService {
  save(params: PrivatePolicyData) {
    return http.post("/private-policy/save", params);
  }

  updateStatus(params: {
    generalUnitId: number | string;
    privatePolicyId: number | string;
    validationStatus: PrivatePolicyValidationStatus;
    overrideTenantName?: string;
    overridePolicyNumber?: string;
    overrideExpiration?: string;
    tenantNameSource?: string;
    policyNumberSource?: string;
    expirationSource?: string;
    rejectionReason?: string;
    sendEmail?: string;
  }) {
    return http.post("/private-policy/update-status", params);
  }
}

export default new PrivatePolicyDataService();
